import API from "@/api/lib/api";

export const getAllburgers = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/burgers`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleBurger = async (item_id) => {
  try {
    const response = await API.get(`restaurant/burgers/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createBurger = async (data) => {
  try {
    const response = await API.post(`restaurant/burgers`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateBurger = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/burgers/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteBurger = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/burgers/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};